import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import useIsMobile from '../../hooks/useIsMobile';
import { GO_BACK_ICON_BUTTON_CLASS_NAME } from '../../theme/constants/icon-button';

const DocumentSummary = ({
  summaryTitle,
  summaryDescription,

  documentTypeId,

  // table props
  showTableButton,
  tableButtonText,
  tableButtonIcon,
  tableButtonOnClick,

  // Custom components
  SummaryTable,
  SummaryData,
  ActionButton,

  // go back button props
  showGoBackButton,
  onGoBackClick,

  // mobile props
  showTableInMobile,
}) => {
  const isMobile = useIsMobile();
  return (
    <Grid container rowSpacing={isMobile ? 0 : 4} px={1.5} pb={3} columnSpacing={2} sx={{ overflowY: 'hidden' }}>
      <Grid item xs={12} sx={{ order: { xs: 1, md: 1 } }}>
        <Box display="flex" alignItems={{ xs: 'flex-start', md: 'center' }} justifyContent="center">
          {showGoBackButton && (
            <Box sx={{ mt: { xs: 2, md: 0 }, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <IconButton
                onClick={onGoBackClick}
                id={`${documentTypeId}-go-back-button`}
                className={GO_BACK_ICON_BUTTON_CLASS_NAME}
              >
                <ArrowBackRoundedIcon sx={{ width: 'inherit', height: 'inherit', color: 'text.primary' }} />
              </IconButton>
            </Box>
          )}
          <Box textAlign="center" flex={1}>
            <Typography variant="medium_3" color="text.primary" component="span" display="block">{summaryTitle}</Typography>
            <Typography
              variant={isMobile ? 'small_2' : 'small_3'}
              fontWeight={500}
              color="text.secondary"
              component="span"
              display="block"
              sx={{
                mb: { xs: 2, md: 0 },
              }}
            >{summaryDescription}
            </Typography>
          </Box>
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        md={SummaryData ? 7 : 12}
        lg={SummaryData ? 8 : 12}
        sx={{
          minHeight: { xs: 0, md: 400 },
          order: { xs: 2, md: 2 },
          marginLeft: showGoBackButton && !SummaryData && !isMobile ? 6 : 0,
        }}
      >
        { (!isMobile || showTableInMobile) && SummaryTable}
        {showTableButton && (
        <Button
          variant="link"
          id={`${documentTypeId}-summary-table-button`}
          startIcon={tableButtonIcon}
          onClick={tableButtonOnClick}
          sx={{ my: 2, height: '22px', width: isMobile ? '100%' : 'auto' }}
        >
          {tableButtonText}
        </Button>
        )}
      </Grid>
      {SummaryData && (
        <Grid item xs={12} md={5} lg={4} sx={{ order: { xs: 2, md: 3 } }}>
          {SummaryData}
          <Box sx={{
            mt: 2,
            mb: isMobile ? 0 : 2,
            width: '100%',
          }}
          >
            {ActionButton}
          </Box>
        </Grid>
      )}
    </Grid>
  );
};
DocumentSummary.propTypes = {
  documentTypeId: PropTypes.string.isRequired,
  summaryTitle: PropTypes.string.isRequired,
  summaryDescription: PropTypes.string.isRequired,
  showTableButton: PropTypes.bool,
  tableButtonText: PropTypes.string,
  tableButtonOnClick: PropTypes.func,
  tableButtonIcon: PropTypes.element,
  ActionButton: PropTypes.element,
  SummaryTable: PropTypes.element.isRequired,
  SummaryData: PropTypes.element,
  showGoBackButton: PropTypes.bool,
  onGoBackClick: PropTypes.func,
  showTableInMobile: PropTypes.bool,
};

DocumentSummary.defaultProps = {
  showTableButton: false,
  tableButtonText: '',
  tableButtonOnClick: () => {},
  tableButtonIcon: <></>,
  showGoBackButton: false,
  onGoBackClick: () => {},
  SummaryData: null,
  ActionButton: null,
  showTableInMobile: false,
};

export default DocumentSummary;
